// extracted by css-extract-rspack-plugin
export default {"cls1":"UserCard-cls1_6gN","cls2":"UserCard-cls2_dRF UserCard-cls1_6gN"};